import React from 'react';
import { Box, Container, Typography, Avatar } from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import LockIcon from '@mui/icons-material/Lock';
import ScheduleIcon from '@mui/icons-material/Schedule';

const ProblemSection = () => {
  const problems = [
    {
      icon: WarningIcon,
      title: 'Finite Databases',
      description:
        'Limited to pre-existing contacts and outdated information that misses emerging talent.',
    },
    {
      icon: LocationOnIcon,
      title: 'Regional Constraints',
      description:
        'Geographic limitations prevent access to global talent pools and diverse perspectives.',
    },
    {
      icon: LockIcon,
      title: 'Closed Communities',
      description:
        'Exclusive networks that limit discovery to known circles and established connections.',
    },
    {
      icon: ScheduleIcon,
      title: 'Lengthy Prospecting',
      description:
        'Traditional outreach takes weeks or months to connect with prospects, slowing down hiring cycles.',
    },
  ];

  return (
    <Box
      component="section"
      sx={{
        py: { xs: 8, md: 12 },
        bgcolor: '#f9fafb',
      }}
    >
      <Container maxWidth="lg">
        {/* ---------- HEADER ---------- */}
        <Box sx={{ textAlign: 'center', mb: { xs: 6, md: 8 } }}>
          <Typography
            sx={{
              fontSize: { xs: '2.2rem', md: '2.75rem' },
              fontWeight: 800,
              color: '#111827',
              mb: 2,
            }}
          >
            The Discovery Problem
          </Typography>

          <Typography
            sx={{
              fontSize: '1.125rem',
              color: '#6b7280',
              maxWidth: 900,
              mx: 'auto',
              lineHeight: 1.7,
            }}
          >
            Traditional search for experienced hires is broken. Limited databases,
            regional constraints, and closed networks restrict your ability to find
            seasoned talent.
          </Typography>
        </Box>

        {/* ---------- PROBLEM ITEMS ---------- */}
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-between',
            rowGap: 6,
          }}
        >
          {problems.map((problem) => (
            <Box
              key={problem.title}
              sx={{
                width: {
                  xs: '100%',
                  sm: '48%',
                  md: '23%',
                },
                textAlign: 'center',
              }}
            >
              {/* ICON */}
              <Avatar
                sx={{
                  width: 64,
                  height: 64,
                  bgcolor: '#fee2e2',
                  color: '#dc2626',
                  mx: 'auto',
                  mb: 3,
                }}
              >
                <problem.icon sx={{ fontSize: 30 }} />
              </Avatar>

              {/* TITLE */}
              <Typography
                sx={{
                  fontSize: '1.15rem',
                  fontWeight: 700,
                  color: '#111827',
                  mb: 1.5,
                }}
              >
                {problem.title}
              </Typography>

              {/* DESCRIPTION */}
              <Typography
                sx={{
                  fontSize: '0.95rem',
                  color: '#6b7280',
                  lineHeight: 1.6,
                }}
              >
                {problem.description}
              </Typography>
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
};

export default ProblemSection;
